import { render, staticRenderFns } from "./plan-a.vue?vue&type=template&id=aeabaa9e&scoped=true"
import script from "./plan-a.vue?vue&type=script&lang=js"
export * from "./plan-a.vue?vue&type=script&lang=js"
import style0 from "./plan-a.vue?vue&type=style&index=0&id=aeabaa9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeabaa9e",
  null
  
)

export default component.exports